import React from 'react';

function StatusBadge({
  label,
  title,
  styleClass = 'bg-slate-100 text-slate-600 border-slate-200',
  icon: Icon,
  compact = false,
  spin = false,
}) {
  const displayLabel = label || '—';
  const tooltip = title || displayLabel;

  if (compact && Icon) {
    return (
      <span
        className={`inline-flex items-center justify-center h-6 w-6 rounded-md border ${styleClass}`}
        title={tooltip}
        aria-label={tooltip}
      >
        <Icon
          className={`h-3.5 w-3.5 shrink-0 ${spin ? 'animate-spin' : ''}`}
          aria-hidden
        />
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium border ${styleClass}`}
      title={title && title !== displayLabel ? title : undefined}
    >
      {Icon && (
        <Icon
          className={`h-3.5 w-3.5 shrink-0 ${spin ? 'animate-spin' : ''}`}
          aria-hidden
        />
      )}
      {displayLabel}
    </span>
  );
}

export default StatusBadge;
